import { useQuery } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";
import { TRateLimitLog } from "../types";

type RateLimitParams = { identifier?: string; endpoint?: string; blocked?: boolean | string; page?: number; limit?: number };

export const useRateLimitLogList = (params: RateLimitParams = { limit: 50 }) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.RATE_LIMIT_LOG, params],
    queryFn: () => client.get(API_ENDPOINTS.RATE_LIMIT_LOG, { params }),
    select: (res: any) => ({
      data: res.data.data as TRateLimitLog[],
      extra: res.data.extra as { total: number; page: number; limit: number },
    }),
    refetchOnWindowFocus: false,
  });
};

export const useRateLimitLogStats = () => {
  return useQuery({
    queryKey: [API_ENDPOINTS.RATE_LIMIT_LOG_STATS],
    queryFn: () => client.get(API_ENDPOINTS.RATE_LIMIT_LOG_STATS),
    select: (res: any) => res.data.data as { total_blocked: number; top_endpoints: Array<{ endpoint: string; hit_count: number }>; top_offenders: Array<{ identifier: string; hit_count: number }> },
    refetchOnWindowFocus: false,
  });
};
